export const TXN_TYPE_MAP: Record<string, string> = {
  campaign_payment: 'Spend',
  admin_topup: 'Topup',
  refund: 'Refund',
  deposit_to_wallet_manual: 'Recharge',
  wallet_to_wallet: 'Transfer',
};

export const getTxnType = (r?: string) => TXN_TYPE_MAP[r || ''] || 'Withdraw';

export const CHART_FILTERS = [
  { value: '', label: 'All Transactions' },
  { value: 'spent', label: 'Spend' },
  { value: 'admin_topup', label: 'Topup' },
  { value: 'refund', label: 'Refund' },
  { value: 'deposit', label: 'Recharge' },
  { value: 'wallet_to_wallet', label: 'Transfer' },
];

export const TXN_FILTERS = [
  { value: '', label: 'All' },
  { value: 'spent', label: 'Spend' },
  { value: 'admin_topup', label: 'Topup' },
  { value: 'refund', label: 'Refund' },
  { value: 'recharg', label: 'Recharge' },
  { value: 'wallet_to_wallet', label: 'Transfer' },
];

export const selectCls =
  'rounded-lg border border-[var(--dash-line)] bg-white px-3 py-2 text-sm text-[var(--dash-ink)] outline-none transition focus:border-[var(--dash-brand)]';
